/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileSummary
 */
export interface ProfileSummary {
    /**
     * Full name of the freelancer
     * @type {string}
     * @memberof ProfileSummary
     */
    fullName: string;
    /**
     * Absolute URL of the freelancer photo
     * @type {string}
     * @memberof ProfileSummary
     */
    photoAbsoluteUrl?: string;
}

/**
 * Check if a given object implements the ProfileSummary interface.
 */
export function instanceOfProfileSummary(value: object): value is ProfileSummary {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function ProfileSummaryFromJSON(json: any): ProfileSummary {
    return ProfileSummaryFromJSONTyped(json, false);
}

export function ProfileSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'photoAbsoluteUrl': json['photoAbsoluteUrl'] == null ? undefined : json['photoAbsoluteUrl'],
    };
}

export function ProfileSummaryToJSON(value?: ProfileSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
        'photoAbsoluteUrl': value['photoAbsoluteUrl'],
    };
}

